export default __webpack_public_path__ + "static/media/yes-you-can.25ad1ece.jpg";